<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';
import logo from '~/assets/images/logo.png';

const { store } = useUser();
const { logout } = useAuth();

const menuItems = computed<DropdownMenuItem[][]>(() => [
  [{
    label: store.user?.displayName ?? 'User',
    avatar: store.userImageUrl ? { src: store.userImageUrl } : undefined,
    type: 'label',
  }],
  [{
    label: 'Logout',
    icon: 'i-lucide-log-out',
    color: 'error',
    onSelect: () => logout(),
  }],
]);
</script>

<template>
  <ClientOnly>
    <UHeader
      v-if="store.user"
      to="#"
      :ui="{
        root: 'border-b border-neutral-200',
        container: 'max-w-full'
      }"
    >
      <template #title>
        <img
          :src="logo"
          alt="Roommejts Logo"
          class="w-20 h-auto rounded-xs bg-primary-500"
        />
      </template>

      <template #right>
        <UDropdownMenu :items="menuItems" :ui="{ content: 'min-w-56' }">
          <button
            type="button"
            class="flex items-center gap-3 p-2 transition-colors duration-200 rounded-md cursor-pointer select-none hover:bg-gray-100"
            :aria-label="`Account menu for ${store.user.displayName ?? 'user'}`"
          >
            <UAvatar
              :src="store.userImageUrl"
              :alt="store.user.displayName ?? 'User'"
              size="md"
              :ui="{ root: 'rounded-full h-10 w-10', image: 'rounded-full' }"
            />
            <span class="hidden sm:inline-flex flex-col items-start leading-tight">
              <span class="font-semibold text-sm">{{ store.user.displayName ?? 'User' }}</span>
              <span class="text-xs text-gray-500">{{ store.user.jobTitle ?? 'Admin' }}</span>
            </span>
          </button>
        </UDropdownMenu>
      </template>
    </UHeader>
  </ClientOnly>
</template>
